import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";
import { ParseOrderRulesToConditionsResult } from "@/features/line-sheet-sets/hooks/use-parse-order-rules-to-conditions";

export interface GetParseOrderRulesJobParameter {
  jobId: string;
}

export interface GetParseOrderRulesJobRequest {}

export interface GetParseOrderRulesJobResponse {
  jobId: string;
  status: string;
  result?: ParseOrderRulesToConditionsResult | null;
  error?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export const getParseOrderRulesJobTemplateUrl = "/parse-order-rules-jobs/:jobId";

export const getParseOrderRulesJobKey: YWRKey<GetParseOrderRulesJobParameter> = {
  url: (parameter) => calcUrl(getParseOrderRulesJobTemplateUrl, parameter),
  method: "get",
};

export default function useGetParseOrderRulesJob() {
  const fetcher = useFetcher<
    GetParseOrderRulesJobRequest,
    GetParseOrderRulesJobResponse
  >();
  return useYWR(getParseOrderRulesJobKey, fetcher);
}
